export default __webpack_public_path__ + "static/media/sql.27f634fc.png";